import React from 'react'
import { Price } from '~/components/utils'
import type { HTMLElementProps, ProductListingFragment } from '~/types'
import { cn, filesUrl, imageUrl } from '~/utils'

export interface UpsellCardProps extends HTMLElementProps<'li'> {
	inCart: boolean
	product: Pick<ProductListingFragment, 'title' | 'featuredImage' | 'priceRange'>
}

export const UpsellCard: React.FC<UpsellCardProps> = ({ inCart, className, product, ...props }) => (
	<li
		className={cn(
			'group grid grid-cols-[1fr,auto] grid-rows-[auto,auto,auto]',
			'xs:text-xl border-3 cursor-pointer select-none rounded-2xl border-solid border-transparent p-2 text-lg',
			className,
			{ 'bg-green/15 border-green-700': inCart }
		)}
		role="button"
		{...props}
	>
		<div className="col-span-2 mb-0 select-none font-bold leading-none">{product.title}</div>
		<img
			className="row-span-2 row-start-2 self-center p-0.5 mix-blend-multiply"
			src={imageUrl(product.featuredImage, 700)}
			loading="lazy"
		/>
		<Price
			className="col-start-2 row-start-2 justify-self-center font-bold"
			price={product.priceRange.minVariantPrice}
			asText
		/>
		<div
			className={[
				'col-start-2 row-start-3 flex items-center justify-center group-hover:opacity-80',
				'xs:h-10 xs:w-10 h-9 w-9 rounded-full text-white',
				inCart ? 'bg-green-700' : 'bg-green'
			].join(' ')}
		>
			{inCart ? (
				<img className="h-4 align-middle brightness-0 invert" src={filesUrl('trash.svg')} alt="delete" />
			) : (
				<span className="text-2xl font-bold">+</span>
			)}
		</div>
	</li>
)
